<template>
    <div>
        <breadcrumb :routerList="[{title:'待办中心'},{title:'延期申请审批'}]"/>
        <div class="h-piece" style="margin:20px">
            <div class="h-pieceIn2">
                <div class="h-pieceTitle2" style="margin-left:10px">
                    <h1>特价信息</h1>
                </div>
                <div class="h-pieceCon2">
                    <div class="h-formLine n-two">
                        <el-form label-position="right" :model="form" :inline="true"
                                 class="demo-ruleForm h-formbLine">

                            <el-form-item label="特价版本号" class="h-elformWrap-2">
                                <el-input v-model="form.specialId" disabled></el-input>
                            </el-form-item>
                            <el-form-item label="客户名称" class="h-elformWrap-2">
                                <el-input v-model="form.username" disabled></el-input>
                            </el-form-item>
                            <el-form-item label="开始时间" class="h-elformWrap-2">
                                <el-input v-model="form.startdate" disabled></el-input>
                            </el-form-item>
                            <el-form-item label="结束时间" class="h-elformWrap-2">
                                <el-input v-model="form.enddate" disabled></el-input>
                            </el-form-item>
                            <el-form-item label="对阵代理商" class="h-elformWrap-2">
                                <el-input v-model="form.contactAgentName" disabled></el-input>
                            </el-form-item>
                            <el-form-item label="特价类型" class="h-elformWrap-2">
                                <el-input v-model="form.categoryName" disabled></el-input>
                            </el-form-item>
                            <el-form-item label="原补传截止日期" class="h-elformWrap-2">
                                <el-input v-model="form.oldDeadline" disabled></el-input>
                            </el-form-item>
                            <el-form-item label="申请延期至" class="h-elformWrap-2">
                                <el-input v-model="form.extensionDate" disabled></el-input>
                            </el-form-item>
                            <el-form-item label="申请人" class="h-elformWrap-2">
                                <el-input v-model="form.applyUser" disabled></el-input>
                            </el-form-item>
                            <el-form-item label="申请时间" class="h-elformWrap-2">
                                <el-input v-model="form.applyTime" disabled></el-input>
                            </el-form-item>

                            <el-form-item label="延期申请附件" class="h-elformWrap-2" v-if="form.extensionFileid">
                                <brupload style="width: 7rem" :refid="form.extensionFileid" reftype="lk_extension" :uploadflag="false" :showtime="false">
                                </brupload>
                            </el-form-item>
                        </el-form>
                    </div>
                </div>
            </div>

            <div class="h-table h-mrt30" v-if="taskstatus == '0'">
                <div class="h-pieceTitle2 hang">
                    <h1>审批意见</h1>
                    <el-form :model="form" label-position="right" :inline="true"
                             class="demo-ruleForm h-formbLine">
                        <el-form-item label="审批意见" class="h-elformWrap-2" style="margin:30px 0 20px 23px" prop="msg" :rules="[{ required: true, message: '请填写审批意见', trigger: 'blur' }]">
                            <el-input v-model="form.msg" placeholder="请输入"></el-input>
                        </el-form-item>
                    </el-form>
                </div>
            </div>

            <div class="anniu" v-if="taskstatus == '0'">
                <el-button class="el-button h-btn h-bBtn h-bgwhite el-button--default" @click="fanhuishangye">返回</el-button>
                <el-button class="el-button h-btn h-bBtn h-bgred el-button--default" @click="doApprove(2)">驳回</el-button>
                <el-button class="el-button h-btn h-bBtn h-bggreen el-button--default" @click="doApprove(1)">通过</el-button>
                <el-button class="h-btn h-bBtn" @click="viewExtensionPress">审批跟踪</el-button>
            </div>
            <div class="anniu" v-if="taskstatus == '1'">
                <el-button class="el-button h-btn h-bBtn h-bgwhite el-button--default" @click="fanhuishangye">返回</el-button>
                <el-button class="h-btn h-bBtn" @click="viewExtensionPress">审批跟踪</el-button>
            </div>
        </div>
        <viewhistory :visible.sync="showhistory" v-if="showhistory" :id="extensionInstid"/>
    </div>
</template>

<script>
import lkService from '../../../api/loud/tejia/lkService'

export default {
    data() {
        return {
            specialId: '',
            taskid: '',
            taskstatus: '',
            extensionInstid: '',
            showhistory: false,
            form: {
                specialId: '',
                username: '',
                startdate: '',
                enddate: '',
                contactAgentName: '',
                categoryName: '',
                oldDeadline: '',
                extensionDate: '',
                extensionFileid: '',
                applyUser: '',
                applyTime: '',
                msg: ''
            }
        }
    },
    created() {
        this.specialId = this.$route.query.specialId || this.$route.query.ywid || ''
        this.taskid = this.$route.query.taskid || ''
        this.taskstatus = this.$route.query.taskstatus || '0'
        if (this.specialId) {
            this.loadData()
        }
    },
    methods: {
        async loadData() {
            try {
                const res = await lkService.getExtensionDetail(this.specialId)
                if (res && res.obj) {
                    const offer = res.obj
                    const dict = this.$store.getters.dictlist ? this.$store.getters.dictlist('category_tejia') : []
                    let categoryName = ''
                    if (dict && dict.length) {
                        const item = dict.find(d => d.code == offer.category)
                        if (item) categoryName = item.name
                    }
                    this.extensionInstid = offer.extensionInstid || ''
                    this.form = {
                        specialId: offer.specialId || '',
                        username: offer.username || '',
                        startdate: offer.startdate || '',
                        enddate: offer.validity || '',
                        contactAgentName: offer.contactAgentName || '',
                        categoryName: categoryName,
                        oldDeadline: offer.supplementDeadline || '',
                        extensionDate: offer.extensionDate || '',
                        extensionFileid: offer.extensionFileid || '',
                        applyUser: offer.lkExtUsername || offer.extensionCucode || '',
                        applyTime: offer.extensionCdate || '',
                        msg: ''
                    }
                }
            } catch (e) {
                console.error('加载延期申请数据失败', e)
            }
        },
        async doApprove(optflag) {
            if (!this.form.msg) {
                this.$msg.msge('请填写审批意见')
                return
            }
            try {
                const res = await lkService.approveExtension({
                    specialId: this.specialId,
                    taskid: this.taskid,
                    optflag: optflag,
                    msg: this.form.msg
                })
                if (res && res.f == true) {
                    this.$msg.alerts(optflag == 1 ? '已通过' : '已驳回', () => {
                        this.$router.back()
                    })
                }
            } catch (e) {
                // 错误信息已由拦截器展示
            }
        },
        viewExtensionPress() {
            this.showhistory = true
        },
        fanhuishangye() {
            this.$router.back()
        }
    }
}
</script>

<style scoped>
.anniu {
    margin-top: 50px;
    display: flex;
    justify-content: center;
    align-items: center;
}
</style>

<style>
.n-two .h-formbLine .h-elformWrap-2 {
    width: 33.333%;
}
.n-two .h-formbLine .el-form-item__label {
    width: 43%;
}
.n-two .h-formbLine .el-form-item__content {
    width: 57%;
}
.n-two .h-formbLine .el-form-item__content .el-select {
    width: 0;
}
.hang {
    padding: 20px 0;
    margin-bottom: 0;
    background-color: white;
}
.hang h1 {
    margin-left: 27px;
}
</style>
